import React, { useEffect, useState } from 'react';
import apiSafibc from '../../axios/axios';
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../toastify/config";
import Swal from 'sweetalert2'
import { useLoginStore } from '../../store/zustend';
import EditIcon from '@mui/icons-material/Edit';
import ModalEditAhorrador from './ModalEditAhorrador';
import { Autocomplete, Button, FormControl, Paper, TextField } from '@mui/material';


const Ahorradores = () => {


    const [ahorradores, setAhorradores] = useState([])
    const [editAhorrador, setEditAhorrador] = useState()
    const [ahorradorselect, setAhorradorselect] = useState()
    const [openModal, setOpenModal] = useState()

    const { loginStore } = useLoginStore()


    const consultarAhorradores = () => {

        const ahorradores = async () => {
            try {
                const cargarAhorradores = await apiSafibc('/ahorradores/obtener-ahorradores', {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setAhorradores(cargarAhorradores.data)


            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar catalogos, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }
        }

        ahorradores()

    }



    const consultarAhorrador = (ahorradorId) => {

        const buscahorrador = async (ida) => {
            try {

                const ia = btoa(ida)

                const cargarAhorrador = await apiSafibc(`/ahorradores/info-ahorrador/${ia}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setAhorradorselect(cargarAhorrador.data)


            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar catalogos, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }
        }

        buscahorrador(ahorradorId)
    }

    useEffect(() => {
        consultarAhorradores()
    }, [])

    const handleChange = (e, id) => {
        e.preventDefault()

        consultarAhorrador(id)
    }

    const cerrarModal = () => {
        setOpenModal(false);
        setAhorradorselect(null);
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">

                    <div className="card shadow">
                        <div className="card-body">
                            <div className="row">
                                <div className='col-md-6 mb-5'>
                                    <FormControl variant="standard" sx={{ minWidth: '100%' }}>

                                        <Autocomplete
                                            disablePortal
                                            options={ahorradores.map((ahorrador) => ({ id: ahorrador.id_ahorrador, label: `${ahorrador.nombre} ${ahorrador.paterno} ${ahorrador.materno}` }))}
                                            onChange={(event, ahorrador) => {
                                                if (!ahorrador) return
                                                handleChange(event, ahorrador.id)
                                            }}
                                            renderInput={(params) => <TextField {...params} label="Ahorrador" variant='standard' />}
                                        />


                                    </FormControl>
                                </div>

                            </div>

                            <div className='table-responsive'>

                                <table className="table">
                                    <thead className='text-center'>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Apellido Paterno</th>
                                            <th>Apellido Materno</th>
                                            <th>Correo</th>
                                            <th>Celular</th>
                                            <th>RFC</th>
                                            <th>HOMOCLAVE</th>
                                            <th>Fecha Nacimiento</th>
                                            <th>Sexo</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-center'>
                                        {ahorradorselect &&
                                            <tr className='animation' key={ahorradorselect.id_ahorrador}>
                                                <td>{ahorradorselect.nombre}</td>
                                                <td>{ahorradorselect.paterno}</td>
                                                <td>{ahorradorselect.materno}</td>
                                                <td>{ahorradorselect.correo}</td>
                                                <td>{ahorradorselect.cel}</td>
                                                <td>{ahorradorselect.rfc}</td>
                                                <td>{ahorradorselect.homoclave}</td>
                                                <td>{ahorradorselect.fecha_nacimiento}</td>
                                                <td>{ahorradorselect.sexo_descr}</td>
                                                <td>
                                                    <Button variant='outlined' onClick={(e) => setOpenModal(true)}>
                                                        <EditIcon />
                                                    </Button>
                                                </td>
                                            </tr>

                                        }
                                    </tbody>

                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />

            {openModal && (
                <ModalEditAhorrador
                    open={openModal}
                    onClose={cerrarModal}
                    ahorrador={ahorradorselect}

                />

            )}



        </div>
    )
}

export default Ahorradores